import React, { createContext, useContext, useEffect, useState } from 'react';
export const UIGameSpectatorsContext = /*#__PURE__*/ createContext({
    spectators: []
});
let globalSetSpectators = ()=>({});
export const setGlobalSpectators = (spectators)=>{
    globalSetSpectators(spectators);
};
export const useUIGameSpectatorsContext = ()=>useContext(UIGameSpectatorsContext);
export const UIGameSpectatorsProvider = ({ initialSpectators, children })=>{
    const [spectators, setSpectators] = useState(initialSpectators || []);
    useEffect(()=>{
        globalSetSpectators = setSpectators;
    }, []);
    return /*#__PURE__*/ React.createElement(UIGameSpectatorsContext.Provider, {
        value: {
            spectators: spectators
        }
    }, children);
};
